<template>
    <div class="converter-status">
        <loading />
        <h2 :class="{ 'highlighted' : converting && !zipping }">Converting your files</h2>
        <h2 :class="{ 'highlighted' : zipping }">Creating the ZIP file</h2>
    </div>
</template>

<script>
import Loading from '@/components/Loading';

export default {
    name: "Status",
    props: {
        converting: {
            type: Boolean,
            default: true
        },
        zipping: {
            type: Boolean,
            default: false
        }
    },
    components: {
        Loading
    }
}
</script>

<style>
.converter-status {
    text-align: center;
}

.converter-status h2 {
    transition: all .25s;
}

.converter-status h2:not(.highlighted) {
    filter: blur(2px);
    transform: scale(.8);
}
</style>


// WEBPACK FOOTER //
// src/components/Status.vue